import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiUser, FiUsers } = FiIcons;

const CoreTeam = () => {
  const teamMembers = [
    {
      id: 1,
      name: "Shahid Shafiq",
      title: "Creative & Campaign Lead",
      profile: "Creative visionary with a strong IT background and 15 + years in branding, film, and digital production. Oversees the artistic direction and technical execution of every campaign asset, ensuring seamless alignment with client goals and fund-raising targets."
    },
    {
      id: 2,
      name: "Dino Caruso",
      title: "Chief Strategy Officer",
      profile: "25 + years across marketing, technology, finance, and real-estate. Provides pragmatic, big-picture strategic oversight—making sure every initiative advances long-term mission and ROI."
    },
    {
      id: 3,
      name: "Manzoor Qadar",
      title: "Content Strategist & Quality-Assurance Specialist",
      profile: "Bilingual (EN/FR) marketing leader with 15 years shaping brand stories. Crafts documentary narratives, email sequences, and social messaging, then QA-checks all content for clarity and cultural resonance."
    },
    {
      id: 8,
      name: "Vicky Shiu Chen",
      title: "Senior Graphic Designer",
      profile: "Crafts all visual assets—event branding, motion lower-thirds, booklet layouts—ensuring a cohesive and compelling visual identity across every touchpoint."
    },
    {
      id: 5,
      name: "Charline Leveille",
      title: "Content & Engagement Manager",
      profile: "Montréal Arts & Communication graduate. Leads multilingual social calendars, moderates livestream chat, and nurtures community engagement to convert viewers into donors."
    },
    {
      id: 6,
      name: "Soffee Petrovski",
      title: "Financial Administrator",
      profile: "Manages budgets, receivables, ad-spend tracking, and transparent financial reporting throughout the project lifecycle."
    },
    {
      id: 7,
      name: "Osama Siddiqui",
      title: "External Collaboration & Resource Integration Lead",
      profile: "Coordinates external contractors, AV crews, and print vendors—bridging technical and creative tasks to keep timelines on track."
    },
    {
      id: 4,
      name: "Alexander Kalpouzos",
      title: "IT Solutions Architect",
      profile: "Designs secure, scalable tech stacks for livestreams, donor portals, and analytics—ensuring every webinar and pledge form works flawlessly."
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <SafeIcon icon={FiUsers} className="w-12 h-12 mx-auto text-[#FF5F1F] mb-4" />
          <h2 className="text-3xl font-bold text-black mb-4">Creatica Core Team — Confirmed Roster</h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {teamMembers.map((member) => (
            <div key={member.id} className="bg-gray-50 rounded-lg p-6 hover:bg-gray-100 transition-colors">
              <div className="flex items-start space-x-4">
                <div className="bg-[#FF5F1F] text-white rounded-full p-3 flex-shrink-0">
                  <SafeIcon icon={FiUser} className="w-6 h-6" />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-black mb-1">
                    {member.name} — {member.title}
                  </h3>
                  <p className="text-gray-700 text-sm leading-relaxed">{member.profile}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreTeam;